import {
    Box,
    Dialog,
    DialogContent,
    IconButton,
    Theme,
    Typography
} from '@mui/material';
import { DialogCloseIcon } from '../../assets/SvgIcons';

interface NomineeOptOutDeclPopupProps {
    open: boolean;
    onClose: () => void;
}

export default function NomineeOptOutDeclPopup({
    open,
    onClose
}: NomineeOptOutDeclPopupProps): JSX.Element {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            sx={(theme: Theme) => ({
                '& .MuiPaper-root': {
                    borderRadius: '25px',
                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                },
            })}
        >
            <DialogContent sx={{ padding: '24px' }}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '16px',
                    }}
                >
                    <Typography variant="h2">
                        Nominee opt out declaration
                    </Typography>
                    <IconButton
                        onClick={onClose}
                        sx={{ padding: '5px' }}
                        aria-label="close-nominee-opt-out-declaration-dialog"
                    >
                        <DialogCloseIcon />
                    </IconButton>
                </Box>
                <Box>
                    <Typography variant="body_500" sx={{ marginBottom: '12px' }}>
                        I hereby confirm that I do not wish to appoint any nominee(s) to my demat account/mutual fund folio at this point of time.
                    </Typography>
                    <Typography variant="body_500" sx={{ marginBottom: '8px' }}>
                        I understand that –
                    </Typography>
                    <Box component="ul" sx={{ paddingLeft: '20px', margin: 0 }}>
                        <Typography component="li" variant="body_500" sx={{ marginBottom: '8px' }}>
                            The nomination helps to quickly identify the person for transfer of securities and helps in faster and smoother transmission of my securities to my legal heir(s) after my demise.
                        </Typography>
                        <Typography component="li" variant="body_500" sx={{ marginBottom: '8px' }}>
                            In the absence of a nomination, my legal heir(s) may require the submission of certain additional legal or court-issued documents which may delay the process of transmission of securities to my legal heir(s).
                        </Typography>
                        <Typography component="li" variant="body_500" sx={{ marginBottom: '8px' }}>
                            If no claim is made on the account / folio for a prolonged period after my demise, the holdings may be treated as unclaimed assets and they may be transferred to Investor Education and Protection Fund Authority (IEPF) in accordance with the applicable regulatory framework.
                        </Typography>
                    </Box>
                    <Typography variant="body_500" sx={{ marginTop: '12px' }}>
                        I confirm that I have understood the above implications and that my decision to opt out of nomination is voluntary.
                    </Typography>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
